/**
 * 文件说明:
 *
 * global 常量
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import defaultAvatar from 'assets/images/avatar.png'
import defaultImage from 'assets/images/default-image.svg'

export default {
    pageSizeOptions: ['10', '20', '50', '100'],
    dateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
    dateMonthFormat: 'MM-DD HH:mm:ss',
    dateFormat: 'YYYY-MM-DD',
    defaultAvatar, // 默认头像
    defaultImage, // 默认图片
    tagType: {
        personal: {
            type: 2,
            text: '个人标签',
        },
        corp: {
            type: 1,
            text: '企业标签',
        },
        mc: {
            type: 3,
            text: '名创标签',
        },
        topToy: {
            type: 4,
            text: 'toptoy会员标签',
        },
        wowColor: {
            type: 5,
            text: 'wowcolor会员标签',
        },
    },
    customerType: {
        wechat: {
            type: 1,
            name: '微信',
        },
        wwork: {
            type: 2,
            name: '企业微信',
        },
    },
    redPacketDefaultAvatarUrl:
        'https://crm-new-prod-1256249764.picsh.myqcloud.com/1/386/e14e26f3870f7f1d0a321884955cd9c3.png', // 小红包默认头像
    mingChuangTagGroupNamePrefix: 'M-',
    topToyTagGroupNamePrefix: 'T-',
    wowColorTagGroupNamePrefix: 'W-',
}
